import axios from "../lib/axios-config";
const getCompanyDetails = ()=>axios.get("/company/details");
const createCompany = (payload)=>axios.post("/company/create", payload);
const acknowledgeTaxClassificationChange = ()=>axios.post("/company/tax-classification-change/acknowledge");
export const CompanyApi = {
    getCompanyDetails,
    createCompany,
    acknowledgeTaxClassificationChange
};
